export enum ConnectionStatus {
  LINKED = 'Linked',
  MANAGED_BY_ATTORNEY = 'Managed By Attorney',
  PENDING_ATTORNEY = 'Pending Attorney Approval',
  PENDING_CLIENT = 'Pending Client Approval',
  ATTORNEY_REJECTED = 'Attorney Rejected',
  CLIENT_REJECTED = 'Client Rejected',
  UNLINKED = 'Not Linked'
}
